import {Button, Chip, Tooltip} from "@mui/material";
import {ArrowDropDown, CancelOutlined, HelpOutline, HourglassTopOutlined, LocalShippingOutlined,
    ScheduleOutlined, TaskAltOutlined} from "@mui/icons-material";
import {useTranslation} from "react-i18next";
import {getAllowedOrderStatusTransitions} from "./order-status-validator";

export const ORDER_STATUS_APPEARANCE = {
    PENDING: {Icon: ScheduleOutlined, foreground: "#8A4B08", background: "#FFF4D6", border: "#D9A441"},
    PROCESSING: {Icon: HourglassTopOutlined, foreground: "#145A86", background: "#E6F3FC", border: "#70A7CB"},
    SHIPPED: {Icon: LocalShippingOutlined, foreground: "#5B3A95", background: "#F1EBFA", border: "#AF98D2"},
    COMPLETED: {Icon: TaskAltOutlined, foreground: "#20663B", background: "#E9F6ED", border: "#86B798"},
    CANCELLED: {Icon: CancelOutlined, foreground: "#A12732", background: "#FCECEF", border: "#DFA0A8"},
};
const unknown = {Icon: HelpOutline, foreground: "#455A64", background: "#F1F4F5", border: "#B0BEC5"};

export default function OrderStatusControl({order, onStatus, disabled, expanded = false}) {
    const {t} = useTranslation();
    const appearance = ORDER_STATUS_APPEARANCE[order.status] || unknown;
    const {Icon, foreground, background, border} = appearance;
    const style = {color: foreground, bgcolor: background, borderColor: border, borderRadius: 1.5,
        fontWeight: 600, fontSize: "0.75rem", whiteSpace: "nowrap"};
    const actionable = Boolean(onStatus && !order.splitDeliveriesAgreed && getAllowedOrderStatusTransitions(order).length);
    if (!actionable) {
        return <Tooltip title={onStatus ? t("NoStatusChangesAllowed") : ""} describeChild>
            <Chip size="small" variant="outlined" icon={<Icon/>} label={t(order.status)}
                sx={{...style, height: 32, "& .MuiChip-icon": {color: foreground, fontSize: 18}}}/>
        </Tooltip>;
    }
    return <Tooltip title={disabled ? "" : t("ChangeStatus")} describeChild>
        <Button id={`order-status-${order.orderId}`} size="small" variant="outlined" disabled={disabled}
            startIcon={<Icon/>} endIcon={<ArrowDropDown/>} aria-haspopup="menu" aria-expanded={expanded}
            aria-controls={expanded ? "order-status-menu" : undefined}
            aria-label={`${t("ChangeStatusForOrder")} ${order.orderNumber}`} onClick={event => onStatus(event, order)}
            sx={{...style, minHeight: 32, px: 1, lineHeight: 1.4,
                "&:hover": {bgcolor: background, borderColor: foreground, boxShadow: `0 0 0 1px ${foreground}`},
                "&.Mui-focusVisible": {outline: `2px solid ${foreground}`, outlineOffset: 2},
                "&.Mui-disabled": {color: foreground, borderColor: border, opacity: 0.6},
                "@media (pointer: coarse)": {minHeight: 44}}}>
            {t(order.status)}
        </Button>
    </Tooltip>;
}
